// Selected-rows bar: approve selected, bulk edit, assign project, export to Excel, undo last bulk edit.
// Part of the Review page (components/Review.jsx). Split out 2026-10-14.
import { bustTipCaches } from './helpers.js';
import { postJson } from '../../api.js';

export default function SelectionBar({ bulkAssignProject, busy, canFilterByStatus, canWrite, handleApproveSelected, isReviewable, lastBulkBatch, pending, projBusy, rawVisible, refresh, selected, setBulkCustomer, setBulkOpen, setBulkReason, setBulkTankSize, setLastBulkBatch, setMsg, setSelected, setStatusFilter, setUndoBusy, statusCounts, statusFilter, tab, undoBusy, visibleRows }) {
  return (
    <>
      {canFilterByStatus && (
        <div className="card" style={{ padding: '0.75rem 1rem', marginBottom: '1rem', display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '0.75rem' }}>
          <strong>{selected.size}</strong> selected of <strong>{visibleRows.length}</strong> visible{statusFilter !== 'all' && <span className="small" style={{ color: '#666' }}> (filter: {statusFilter})</span>}
          {canWrite && isReviewable && (
          <button className="refresh-btn" disabled={busy || selected.size === 0} onClick={handleApproveSelected} style={{ background: '#16a34a' }}>
            Approve selected → add to Approved
          </button>
          )}
          {isReviewable && (
          <button className="refresh-btn" disabled={busy || selected.size === 0}
            onClick={() => { setBulkOpen(true); setBulkCustomer(''); setBulkTankSize(''); setBulkReason(''); }}
            style={{ background: '#7c3aed' }}
            title="Set customer and/or tank size on every selected row in one shot">
            ✏️ Bulk edit ({selected.size})
          </button>
          )}
          {canWrite && (
          <button className="refresh-btn" disabled={busy || projBusy || selected.size === 0}
            onClick={bulkAssignProject}
            style={{ background: '#9333ea' }}
            title="Assign every selected tip to a project (all selected tips must belong to one customer)">
            📁 Assign project ({selected.size})
          </button>
          )}
          {lastBulkBatch && (
            <button className="refresh-btn" disabled={undoBusy}
              onClick={async () => {
                if (!confirm('Undo last bulk edit (' + lastBulkBatch.count + ' rows: ' + lastBulkBatch.label + ')?')) return;
                setUndoBusy(true); setMsg(null);
                try {
                  const r = await postJson('/api/google/correct-undo', { batchId: lastBulkBatch.batchId });
                  setMsg('Undo complete: reverted ' + r.reverted + ' row(s)' + (r.missing ? ' (' + r.missing + ' missing)' : '') + '.');
                  setLastBulkBatch(null);
                  bustTipCaches(); await refresh();
                } catch (e) { setMsg('Undo failed: ' + e.message); }
                finally { setUndoBusy(false); }
              }}
              style={{ background: '#ca8a04' }}
              title={'Restore prior values for the ' + lastBulkBatch.count + ' rows in that batch'}>
              {undoBusy ? 'Undoing…' : '⤺ Undo bulk (' + lastBulkBatch.count + ')'}
            </button>
          )}
          {isReviewable && statusFilter !== 'clean' && statusCounts && statusCounts.clean > 0 && (
            <button className="refresh-btn" disabled={busy} style={{ background: '#0369a1' }}
              onClick={() => {
                setStatusFilter('clean');
                // Re-derive the clean rows from rawVisible so we can select them
                const cleanRows = rawVisible.filter(r => (r._issues || []).length === 0);
                setSelected(new Set(cleanRows.map(r => r._id).filter(Boolean)));
              }}>
              ⚡ Select all Clean ({statusCounts.clean})
            </button>
          )}
          {isReviewable && statusCounts && statusCounts.priorApproved > 0 && (
            <button className="refresh-btn" disabled={busy} style={{ background: '#15803d' }}
              onClick={() => {
                setStatusFilter('prior-approved');
                const okRows = rawVisible.filter(r => (r._issues || []).includes('plate_customer_mismatch') && (r._priorApprovals || 0) > 0);
                setSelected(new Set(okRows.map(r => r._id).filter(Boolean)));
              }}
              title="Mismatch rows where the same plate+customer combo was approved before — historically these are operator shorthand for known customers.">
              ⚡ Select all prior-approved mismatches ({statusCounts.priorApproved})
            </button>
          )}
          <span className="small" style={{ marginLeft: 'auto', color: '#666' }}>
            {tab === 'pending' ? 'Pending = post-Jun-15 sheet rows.' : 'Unmatched = pre-Jun-15 sheet rows that don\'t line up with any Approved row.'} Approving inserts only those without an existing Approved match.
          </span>
        </div>
      )}
    </>
  );
}
